import React, { useState, useEffect, useCallback } from "react";
import CustomSideNavBar from "./customSideNavBar"


function CustomHeaderComponent(props) {
    const [sidebarVal, setSideBarVal] = useState(false)

    const closeSideNavBar = () => {
        setSideBarVal(false)
        document.body.style.overflow = "auto"
    }

    const showSideNavBar = () => {
        setSideBarVal(true)
        document.body.style.overflow = "hidden"
    }


    return (
        <div style={{ display: "flex", flexDirection: 'row', alignItems: "center",}}>
            <svg style={{ cursor: "pointer", }} onClick={() => showSideNavBar()} className="side_bars_icon" xmlns="http://www.w3.org/2000/svg" width="43" height="34" viewBox="0 0 43 34" fill="none">
               <path d="M3.3682 17H38.3996M24.9256 30.4736H38.3992M3.36816 3.52637H16.8418" stroke="#303030" strokeWidth="5.38947" strokeLinecap="round"/>
            </svg>

            <CustomSideNavBar {...props} sidebarVal={sidebarVal} showSideNavBar={showSideNavBar} closeSideNavBar={closeSideNavBar} />

            <div>
                <h1 className="screen_name_cls" style={{ color: "#303030", fontWeight: 700, fontFamily: "Roboto" }}>
                    {props.screenName}
                </h1>
            </div>

        </div>
        // </div>
    );
}
export default CustomHeaderComponent;
